export const state = {
    data: null,
    isAdmin: false,
    vGroups: []
}

export const mutations = {
    SET_DATA(state, payload) {
        state.isAdmin = payload.isAdmin

        state.data = payload.access
    },
    SET_VGROUPS(state, payload) {
        state.vGroups = payload
    }
}
